import { render, staticRenderFns } from "./CertificatesImport.vue?vue&type=template&id=1c45659e"
import script from "./CertificatesImport.vue?vue&type=script&lang=ts"
export * from "./CertificatesImport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports